import { Button } from 'antd'

import { auditAuctionApi } from '@eastcoal/api/trade/auctionOperation/auditAuction'

import { useRemoteTableStore } from '@eastcoal/common/components/RemoteTable/Store/hooks/useStore'
import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { pick } from '@eastcoal/common/utils/object'

import { CrudPopform } from '@eastcoal/formily/components/CrudPopform'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { RadioGroup } from '@eastcoal/formily/components/Radio'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'
import { TextArea } from '@eastcoal/formily/components/TextArea'

import { AuctionOperationPageStatus } from '../../../enums/AuctionOperationPageStatus'

import { AuctionAuditButtonProps } from './interface'

const schema: SchemaItem[] = [
  {
    name: 'id',
    type: 'string',
    'x-display': 'hidden'
  },
  {
    name: 'successful',
    type: 'boolean',
    title: '结果',
    enum: [
      {
        label: '通过',
        value: true
      },
      {
        label: '不通过',
        value: false
      }
    ],
    'x-component': RadioGroup,
    'x-decorator': FormItem
  },
  {
    name: 'reason',
    type: 'string',
    title: '原因',
    required: '{{ !$values.successful }}',
    'x-component': TextArea,
    'x-decorator': FormItem
  }
]

export const AuctionAuditButton = ({ record }: AuctionAuditButtonProps) => {
  const { message } = useFeedback()
  const { reload } = useRemoteTableStore(state => pick(state, ['reload']))

  const handleSubmitSuccess = async () => {
    message.success('审核成功')
    reload()
  }

  return record.status === AuctionOperationPageStatus.WAIT_AUDIT ? (
    <CrudPopform
      api={auditAuctionApi}
      name='auditAuctionForm'
      schema={schema}
      title='审核'
      type='success'
      initialValues={{
        id: record.id,
        successful: true
      }}
      onSuccess={handleSubmitSuccess}
    >
      <Button type='link'>审核</Button>
    </CrudPopform>
  ) : null
}
